/**
 * This file is safe to modify, your changes will NOT be lost on next generation!
 * Generated code from template "service-class-extends.velocity"
 */

// tslint:disable
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { RegbpServiceBase } from "./regbp.service-base";
import { AppConfigService } from "@justonweb/core";

@Injectable({providedIn: 'root'})
export class RegbpService extends RegbpServiceBase {

    constructor(private appConfig: AppConfigService, http: HttpClient) {
        super(http);
    }

  buildPath(relativePath: string): string {
    return this.appConfig.getConfig().apiUrl + relativePath;
  }

}


/** end of template "service-class-extends.velocity" */
